import {WATERFALL_SHAPES_KEY} from "../../../../../constants";
import SqftStore from "../../sqftStore";
import SlabWorkspace from "../../../core/slab/slabWorkspace";
import {createSlabModeWaterfallShapes} from "../../canvasHelper";

const additionalShapesRefreshTimers = new Map();

export class WaterfallSegmentController {

  constructor(parentController) {
    this.parentController = parentController;
  }

  updateWaterfallLength = (line) => {
    if (!line.isWithWaterfallToolEdge() || !line.isWithPeninsulaUnderwrapEdge()) {
      return
    }
    const waterfallOverlay = this.parentController.getResourceByLineId(line.id);
    for (const waterfallOverlaySegment of waterfallOverlay.getSegments()) {
      if (waterfallOverlaySegment.name === WATERFALL_SHAPES_KEY.waterfall
        || waterfallOverlaySegment.name === WATERFALL_SHAPES_KEY.underlayment
      ) {
        waterfallOverlaySegment.length = line.getLineLength();
      }
    }
    this.parentController.changeWaterfallSectionInStore(waterfallOverlay.exportData());
  }

  scheduleAdditionalShapesRefresh = (line) => {
    const lineId = line?.id;
    if (!lineId) {
      return;
    }

    const existingTimer = additionalShapesRefreshTimers.get(lineId);
    if (existingTimer) {
      window.clearTimeout(existingTimer);
    }

    const refreshAdditionalShapes = () => {
      if (window.lineInputFocused) {
        const deferredTimer = window.setTimeout(refreshAdditionalShapes, 100);
        additionalShapesRefreshTimers.set(lineId, deferredTimer);
        return;
      }

      additionalShapesRefreshTimers.delete(lineId);

      const currentLine = this.parentController.getResourceByLineId(lineId)?.line;
      if (!currentLine) {
        return;
      }

      SlabWorkspace.slabAdditionalShapes.removeActiveBacksplashByLine(currentLine);
      SlabWorkspace.slabAdditionalShapes.initWaterfallToolShapes();
      SlabWorkspace.slabAdditionalShapes.initBacksplashAndEdgeShapes();
      if (!SqftStore.isSlabMode()) {
        SlabWorkspace.slabAdditionalShapes.hideAdditionalShapes();
      }
      SqftStore.updateCalculations();
    };

    const refreshTimer = window.setTimeout(refreshAdditionalShapes, 100);

    additionalShapesRefreshTimers.set(lineId, refreshTimer);
  }

  changeSegmentLength = (segmentId, newValue) => {
    const segment = this.parentController.getSegmentById(segmentId);
    const waterfallOverlay = segment.getParent();
    segment.length = +newValue

    this.parentController.changeWaterfallSectionInStore(waterfallOverlay.exportData());
    this.postChangeValue(waterfallOverlay.id);
  }

  changeSegmentHeight = (segmentId, newValue) => {
    const updatedSegment = this.parentController.getSegmentById(segmentId);
    const waterfallOverlay = updatedSegment.getParent();

    if (updatedSegment.COMMON_HEIGHT.includes(updatedSegment.name)) {
      for (const waterfallOverlaySegment of waterfallOverlay.getSegments()) {
        if (waterfallOverlaySegment.COMMON_HEIGHT.includes(waterfallOverlaySegment.name)) {
          waterfallOverlaySegment.height = +newValue;
        }
      }
    } else {
      updatedSegment.height = +newValue;
    }

    this.parentController.changeWaterfallSectionInStore(waterfallOverlay.exportData());
    this.postChangeValue(waterfallOverlay.id);
  }

  changeSegmentThickness = (segmentId, newValue) => {
    const segment = this.parentController.getSegmentById(segmentId);
    const waterfallOverlay = segment.getParent();
    segment.thickness = +newValue

    this.parentController.changeWaterfallSectionInStore(waterfallOverlay.exportData());
    this.postChangeValue(waterfallOverlay.id);
  }

  changeSegmentIsDisabled = (segmentId, newValue) => {
    const waterfallSegment = this.parentController.getSegmentById(segmentId);
    const waterfallOverlay = waterfallSegment.getParent();
    waterfallSegment.setIsDisabled(newValue);

    this.parentController.changeWaterfallSectionInStore(waterfallOverlay.exportData());
    this.postChangeValue(waterfallOverlay.id);
  }

  postChangeValue = (overlayId) => {
    // remove all slab shapes
    const overlay = this.parentController.getResourceById(overlayId);
    SlabWorkspace.slabAdditionalShapes.removeActiveBacksplashByLine(overlay.line);

    //reCreate Slab Shapes
    createSlabModeWaterfallShapes();

    // update calculations
    SqftStore.updateCalculations();
  }

}
